module.exports = __webpack_public_path__ + "static/media/learnMore.f85f3974.mp3";